(function () {
  'use strict';

  const SELECTED_CLASS = 'is-selected';

  const routes = (window.FoxTheme && window.FoxTheme.routes) || {};
  const CART_ADD_URL = (routes.cart_add_url || '/cart/add') + '.js';
  const CART_URL = routes.cart_url || '/cart';

  // Cuando el ajuste del tema `cart_type` es "page", theme.js no intercepta el
  // formulario: se envía de forma nativa y el evento `product-ajax:added` nunca
  // llega. En ese modo tenemos que mandar producto + extras nosotros.
  const isCartPageMode = !window.FoxTheme || !window.FoxTheme.settings || window.FoxTheme.settings.cartType === 'page';

  // ── Variant select: update input value and price display ────────────────────

  document.querySelectorAll('.yith-addon-variant-select').forEach((select) => {
    select.addEventListener('change', function (e) {
      e.stopPropagation(); // prevent bubbling to label click

      const inputId = this.dataset.input;
      const input = document.getElementById(inputId);
      if (!input) return;

      // Update the hidden input value to the chosen variant id
      input.value = this.value;

      // Update price label
      const selectedOption = this.options[this.selectedIndex];
      const priceEl = this.closest('.yith-addon-item__body')?.querySelector('.yith-addon-item__price');
      if (priceEl && selectedOption.dataset.price) {
        priceEl.textContent = '+' + selectedOption.dataset.price;
      }
    });
  });

  // ── Input change: toggle is-selected on card ─────────────────────────────────

  document.querySelectorAll('.yith-addon-input').forEach((input) => {
    input.addEventListener('change', function () {
      const label = this.closest('.yith-addon-item');
      if (!label) return;

      if (this.type === 'radio') {
        // Deselect every card in the same radio group
        document.querySelectorAll(`input[name="${this.name}"]`).forEach((el) => {
          el.closest('.yith-addon-item')?.classList.remove(SELECTED_CLASS);
        });
        label.classList.add(SELECTED_CLASS);
      } else {
        label.classList.toggle(SELECTED_CLASS, this.checked);
      }
    });
  });

  // ── Helpers ──────────────────────────────────────────────────────────────────

  function getMainForm() {
    return document.querySelector('form.main-product-form');
  }

  function getQuantity(form) {
    // El selector de cantidad puede estar fuera del <form> y asociado por el
    // atributo `form`, así que form.elements lo encuentra y querySelector no.
    const input =
      (form && form.elements && form.elements.namedItem('quantity')) ||
      document.querySelector('.main-product-form [name="quantity"], .main-product-form .quantity__input');
    if (!input) return 1;
    return Math.max(1, parseInt(input.value, 10) || 1);
  }

  function getSelectedAddonItems(quantity) {
    return [...document.querySelectorAll('.yith-addon-input:checked')]
      .map((input) => ({ id: parseInt(input.value, 10), quantity }))
      .filter((item) => Number.isFinite(item.id) && item.id > 0);
  }

  function addItemsToCart(items) {
    return fetch(CART_ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    }).then(async (response) => {
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw error;
      }
      return response.json();
    });
  }

  // ── Modo "carrito en página": enviamos producto + extras nosotros ────────────

  if (isCartPageMode) {
    const form = getMainForm();

    if (form) {
      form.addEventListener('submit', function (event) {
        const quantity = getQuantity(form);
        const addonItems = getSelectedAddonItems(quantity);

        // Sin extras marcados no hay nada que hacer: envío nativo de siempre.
        if (addonItems.length === 0) return;
        if (form.dataset.yithSubmitting === 'true') return;

        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput || variantInput.disabled || !variantInput.value) return;

        event.preventDefault();
        form.dataset.yithSubmitting = 'true';

        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.setAttribute('aria-busy', 'true');

        const items = [{ id: parseInt(variantInput.value, 10), quantity }, ...addonItems];

        addItemsToCart(items)
          .then(() => {
            window.location.href = CART_URL;
          })
          .catch((error) => {
            console.error('[yith-addon] Cart add error:', error);
            // Si algo falla, al menos que entre el producto principal.
            form.submit();
          });
      });
    }

    return;
  }

  // ── Modo "carrito lateral": el tema ya añade el producto por AJAX ────────────

  document.addEventListener('product-ajax:added', async () => {
    const form = getMainForm();
    const quantity = getQuantity(form);
    const addonItems = getSelectedAddonItems(quantity);

    if (addonItems.length === 0) return;

    try {
      await addItemsToCart(addonItems);

      // Refresh the cart drawer content (without reopening it)
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: false },
        })
      );
    } catch (error) {
      console.error('[yith-addon] Cart add error:', error);
    }
  });
})();
